<template>
  <div class="ova">
    <div class="left-hand">
      <div class="Pngfute">
        <div class="oimg"></div>
      </div>
      <div class="state"></div>
      <div class="trigger">
        <div class="swtrGet" @click="drawer = true" type="primary" style="margin-left: 16px">
          <i class="el-icon-sort"></i> 切换进线
        </div>
        <el-drawer title="回路" :visible.sync="drawer" :with-header="false">
          <ul class="infinite-list" style="overflow: auto">
            <div class="upward" @click="roll(1)">上</div>
            <div ref="apk" v-dragscroll class="vue-drag-scroll-out-wrapper">
              <div class="vue-drag-scroll-wrapper" :style="zoomStye">
                <li
                  @click="add(item.id)"
                  v-for="item in bgonClick"
                  class="jadk"
                  :key="item.id"
                >{{ item.name }}</li>
                <li class="nonum">没有更多了</li>
              </div>
            </div>
            <div class="downward" @click="roll(2)">下</div>
          </ul>
          <!-- <div class="jadk" v-for="item in bgonClick" :key="item.id">{{item.name}}</div> -->
        </el-drawer>
      </div>
    </div>
    <!-- <div class="mar" v-if="Isshow==0"><div class="tors"><img src="../assets/img/缺省插图.png" alt=""><p class="oP">暂无数据,<router-link class="a" to="">刷新</router-link>请尝试或选择回路</p></div></div> -->
    <div class="javafort" v-if="Isshow!=0">
      <div class="table-ele">
        <el-table
          :row-class-name="tableRowClassName"
          :header-cell-style="tableHeaderColor"
          :data="data"
          border
          prop="name"
          width="100%"
        >
          <el-table-column prop="name" width="173px" height="40px" label></el-table-column>
          <el-table-column prop="amount1" label="A/ab" height="40px" width="173px"></el-table-column>
          <el-table-column prop="amount2" label="B/bc" height="40px" width="173px"></el-table-column>
          <el-table-column prop="amount3" label="C/ac" height="40px" width="173px"></el-table-column>
          <el-table-column prop="amount4" label="总" height="40px" width="173px"></el-table-column>
          <el-table-column prop="spanw" label="单位" height="40px" width="173px"></el-table-column>
        </el-table>
      </div>
      <div class="Temperature">
        <div class="web-left">
          <div class="header">
            <div class="header-one">1</div>
            <div class="felx-right">
              <div class="header-name">主母线温度/℃</div>
              <div class="header-Icon">
                <img src="../assets/img/温度.png" alt />
              </div>
            </div>
          </div>
          <div class="demo1">
            <em>&#9670;</em>
            <span>&#9670;</span>
          </div>
          <div class="Temperature-item">
            <div class="ABC">
              <span>温度#A</span>
              <span>11</span>
            </div>
            <div class="ABC">
              <span>温度#B</span>
              <span>22</span>
            </div>
            <div class="ABC">
              <span>温度#C</span>
              <span>33</span>
            </div>
          </div>
        </div>
        <div class="web-left">
          <div class="header">
            <div class="header-one">2</div>
            <div class="felx-right">
              <div class="header-name">主母线温度/℃</div>
              <div class="header-Icon">
                <img src="../assets/img/温度.png" alt />
              </div>
            </div>
          </div>
          <div class="demo1">
            <em>&#9670;</em>
            <span>&#9670;</span>
          </div>
          <div class="Temperature-item">
            <div class="ABC"></div>
            <div class="ABC"></div>
            <div class="ABC"></div>
          </div>
        </div>
        <div class="web-left">
          <div class="header">
            <div class="header-one">3</div>
            <div class="felx-right">
              <div class="header-name">主母线温度/℃</div>
              <div class="header-Icon">
                <img src="../assets/img/温度.png" alt />
              </div>
            </div>
          </div>
          <div class="demo1">
            <em>&#9670;</em>
            <span>&#9670;</span>
          </div>
          <div class="Temperature-item">
            <div class="ABC"></div>
            <div class="ABC"></div>
            <div class="ABC"></div>
          </div>
        </div>
      </div>
      <div class="Humidity">
        <div class="web-left">
          <div class="header">
            <div class="felx-right">
              <div class="header-name">主母线温度/℃</div>
              <div class="header-Icon">
                <img src="../assets/img/矢量智能对象.png" alt />
              </div>
            </div>
          </div>
          <div class="demo1">
            <em>&#9670;</em>
            <span>&#9670;</span>
          </div>
          <div class="Temperature-item">
            <div class="ABC"></div>
            <div class="ABC"></div>
            <div class="ABC"></div>
          </div>
        </div>
        <div class="web-left">
          <div class="header">
            <div class="felx-right">
              <div class="header-name">主母线温度/℃</div>
              <div class="header-Icon">
                <img src="../assets/img/矢量智能对象(1).png" alt />
              </div>
            </div>
          </div>
          <div class="demo1">
            <em>&#9670;</em>
            <span>&#9670;</span>
          </div>
          <div class="Temperature-item">
            <div class="ABC"></div>
            <div class="ABC"></div>
            <div class="ABC"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="mar" v-else>
      <div class="tors">
        <img src="../assets/img/not_found_data.png" alt />
        <div class="oP">
          暂无数据，请尝试
          <span class="antfos" @click="forsClick()" style="color:#0D94FF">刷新</span>或选择进线
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import chainIndex from "../api/play";
export default {
  data() {
    return {
      //显示有数据
      Isshow: 0,
      //触摸滚动
      scale: 100,
      //回路弹窗状态
      drawer: false,
      //回路切换
      bgonClick: [
        {
          id: 1,
          name: "回路一",
        },
        {
          id: 2,
          name: "回路二",
        },
        {
          id: 3,
          name: "回路三",
        },
        {
          id: 4,
          name: "回路三",
        },
        {
          id: 5,
          name: "回路三",
        },
        {
          id: 6,
          name: "回路三",
        },
        {
          id: 7,
          name: "回路三",
        },
        {
          id: 8,
          name: "回路三",
        },
        {
          id: 9,
          name: "回路三",
        },
        {
          id: 10,
          name: "回路三",
        },
        {
          id: 11,
          name: "回路三",
        },
        {
          id: 12,
          name: "回路三",
        },
        {
          id: 13,
          name: "回路三",
        },
        {
          id: 14,
          name: "回路三",
        },
        {
          id: 15,
          name: "回路三",
        },
        {
          id: 16,
          name: "回路三",
        },
        {
          id: 17,
          name: "回路三",
        },
        {
          id: 18,
          name: "回路三",
        },
        {
          id: 19,
          name: "回路三",
        },
        {
          id: 22,
          name: "回路三",
        },
        {
          id: 33,
          name: "回路三",
        },
      ],
      data: [
        {
          id: "1",
          name: "任务名称",
          amount4: 10,
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
        },
        {
          id: "2",
          name: "任务名称1",
          amount4: 10,
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
        },
        {
          id: "3",
          name: "任务名称2",
          amount1: "234",
          amount2: "3.2",
          amount4: 10,
          amount3: 1,
          spanw: "v",
        },
        {
          id: "4",
          name: "任务名称",
          amount1: "234",
          amount2: "3.2",
          amount4: 10,
          amount3: 10,
          spanw: "v",
        },
        {
          id: "5",
          name: "任务名称1",
          amount1: "234",
          amount2: "3.2",
          amount4: 10,

          amount3: 10,
          spanw: "v",
        },
        {
          id: "6",
          amount4: 10,
          name: "任务名称2",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
        },
        {
          id: "7",
          name: "任务名称",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
          amount4: 10,
        },
        {
          id: "8",
          name: "任务名称1",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
          amount4: 10,
        },
        {
          id: "9",
          name: "任务名称2",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
          amount4: 10,
        },
      ],
    };
  },
  computed: {
    zoomStye() {
      //  const INIT_WIDTH = 2208
      //  const width = INIT_WIDTH * (1 + (100 - this.scale)/100)
      //  console.log(width)
      const INIT_HEIGHT = 1206;
      const height = INIT_HEIGHT * (1 + (100 - this.scale) / 100);
      console.log(height);
      return {
        // width: `${width}px`,
        height: `${height}px`,
        transform: `scale(${this.scale / 100})`,
      };
    },
  },
  mounted() {
    this.app();
  },
  methods: {
    //刷新页面
    forsClick() {
      this.$router.go(0);
    },
    //点击滚动条事件
    roll(index) {
      if (index == 2) {
        //滚动的数值  或者  +- = 值  或者死的数值 就是相应位置
        //还有相应的 scrollTop 方法
        console.log(this.$refs.apk);
        this.$refs.apk.scrollTop += 100;
      } else {
        console.log(this.$refs.apk.scrollTop);
        this.$refs.apk.scrollTop -= 100;
      }
    },

    //模拟接口请求
    app() {
      chainIndex.analogInterface(2).then((res) => {
        this.Isshow = res.data.data.deviceLoops.length;
        console.log(res.data.data.deviceLoops.length);
      });
    },
    //点击事件
    add(index) {
      if (index) {
        this.drawer = false;
      }
    },
    //改变表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        console.log(row, column, columnIndex);
        return "background-color:rgba(0, 0, 0,0.06);color: #000000;font-weight: 700";
      }
    },
    //改变table颜色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 != 0) {
        //=>这里可以改成 rowIndex%2=== 1，后面直接else即可达到隔行变色效果。
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
 <style lang="less" scoped>
.ova {
  display: flex;
  // padding-left: 23px;
  .infinite-list {
    height: 900px;
  }
  // .infinite-list::-webkit-scrollbar {
  //   display: none;
  // }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .left-hand {
    .Pngfute {
      width: 330px;
      height: 602px;
      padding: 25px 0;
      background-image: url(../assets/img/bg.png);
      .oimg {
        width: 280px;
        height: 552px;
        background-color: #fff;
        margin: auto;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .state {
      margin-top: -2px;
      background-image: url(../assets/img/倒影@2x.png);
      background-size: 100% 100%;
      width: 330px;
      height: 53px;
      margin-bottom: 6px;
    }
    .trigger {
      margin: auto;
      width: 195px;
      height: 81px;
      background-image: url(../assets/img/btnstuts.png);
      background-size: 195px 81px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0px 10px 10px 0;
      .jadk {
        text-align: center;
        line-height: 50px;
        border-bottom: 1px solid rgb(209, 206, 206);
      }
      .jadk:hover {
        box-shadow: 20px 10px 40px rgb(214, 210, 210);
      }
      .el-icon-sort {
        font-size: 22px;
      }
      .swtrGet {
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        cursor: pointer;
        margin-left: 8px;
        // margin-top: 4px;
      }
    }
  }
  .javafort {
    margin-left: 23px;
    .table-ele {
      width: 1040px;
      height: 400px;
    }
    .Humidity,
    .Temperature {
      // background-color: rebeccapurple;
      margin-top: 16px;
      display: flex;
      .web-left {
        width: 240px;
        // display: flex;
        // margin-left: 22px;
        position: relative;
        margin-right: 32px;
        .header {
          width: 240px;
          height: 34px;
          background-image: url(../assets/img/terrfunt.png);
          background-color: #fff;
          display: flex;
          align-items: center;
          padding: 0 16px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          box-shadow: 0px 1px 5px 0px rgba(14, 5, 10, 0.1) inset;

          color: rgba(51, 51, 51);
          border-radius: 2px;

          .felx-right {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-left: 8px;
            .header-Icon {
              width: 10px;
              height: 18px;
            }
          }
          .header-one {
            width: 16px;
            height: 16px;
            background: #ff9d4d;
            font-weight: 400;
            color: #ffffff;
            font-size: 14px;
            text-align: center;
            line-height: 16px;
            border-radius: 2px;
          }
        }
        .Temperature-item {
          // background-color: blue;
          width: 240px;
          height: 96px;
          margin-top: 12px;
          background: #ffffff;
          border: 1px solid rgba(14, 5, 10, 0.06);
          box-shadow: 0px 4px 10px 0px rgba(14, 5, 10, 0.1);

          .ABC {
            padding-left: 17px;
            padding-right: 5px;
            width: 100%;
            line-height: 32px;
            height: 32px;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            border: 1px solid rgba(0, 0, 0, 0.15);
            span:last-child {
              color: black;
              font-weight: 400;
            }
            span {
              color: #999999;
              font-weight: 400;
            }
          }
        }
      }
    }
    .Humidity {
      margin-top: 19px;
    }
  }
}
.demo1 {
  em,
  span {
    display: block;
    width: 30px;
    height: 16px;
    font-size: 30px;
    overflow: hidden;
    position: absolute;
    top: 47px;
    left: 203px;
  }
  em {
    margin-top: -16px;
    color: rgba(0, 0, 0, 0.15);
    font-style: normal;
  }
  span {
    margin-top: -14px;
    color: white;
  }
}
.vue-drag-scroll-wrapper {
  margin-top: 50px;
}
.vue-drag-scroll-out-wrapper::-webkit-scrollbar {
  display: none;
}
.vue-drag-scroll-out-wrapper {
  width: 100%;
  overflow-x: hidden;
  /* width: 100%; */
  height: 100%;
  cursor: grab;
  position: absolute;
  top: 0;
  left: 0;
}
.mar {
  margin: auto;
  .tors {
    width: 400px;
    height: 400px;
    margin: auto;
    // background-color: red;
    text-align: center;
    img {
      margin-top: 88px;
      margin-right: 80px;
      margin-left: 80px;
    }
    .oP {
      font-size: 18px;
      font-weight: 400;
      color: #999999;
      margin-top: 24px;
    }
  }
}
.fors {
  display: flex;
  // text-align: center;
}
.a {
  color: #0d94ff;
}
.upward {
  position: absolute;
  width: 100%;
  height: 50px;
  top: 0;
  background-color: #ffffff;
  text-align: center;
  font-size: 28px;
  line-height: 50px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.4);
  z-index: 9999;
  box-shadow: 5px 1px 5px 1px gray;
}
.downward {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50px;
  background-color: #fff;
  text-align: center;
  line-height: 50px;
  font-size: 28px;
  border-top: 1px solid rgba(128, 128, 128, 0.4);
  z-index: 9999;
  box-shadow: 5px 5px 5px 5px gray;
}
.nonum {
  text-align: center;
  margin-top: 20px;
  color: rgb(189, 189, 189, 0.5);
}

// .terr{
//   position: absolute;
//       width: 0;
//     height: 0;
//     left: 208px;
//     top: 40px;
//   border-left:10px solid transparent;
//     border-right:10px solid transparent;
//     border-bottom:10px solid rgba(0, 0, 0, 0.15);;
// }
// .Temperature-item:before{
//      width: 20px;
//      height: 20px;
//     position:absolute;

//     border-top:0.6rem solid transparent;
//     border-right:0.6rem solid #F2F6F4 ;
//     border-bottom: 0.6rem solid transparent;

// }
</style>